import { createInitSentry } from '@bos/sentry';

import { buildtimeEnv } from '../../buildtimeEnv';
import { env } from '../../env';

export const { isSentryEnabled, initSentry } = createInitSentry({
	appName: 'backoffice-valhalla',
	dsn: env.CLIENT_SENTRY_DSN,
	environment: env.CLIENT_ENVIRONMENT,
	version: buildtimeEnv.CLIENT_VERSION,
	tracesSampleRate: 1,
});
